@if (accommodation$ | async; as accommodation) {
	<section class="container">
		@if (accommodation.locations.length > 0) {
			<div
				class="!border-b-0 divider"
				id="uniAccommodation"
				data-cy="uni-accommodation"
			>
				<div class="pb-2">
					<div class="relative flex justify-between gap-6">
						<h2 class="secondary-header">
							{{ uniName() }} Accommodation Choices
						</h2>
						@if (accommodation.locations.length > 1) {
							<div class="flex items-center gap-3">
								<p
									class="carousel-pagination carousel-index-accommodation"
								></p>
								<div class="hidden gap-3 sm:flex">
									<div
										data-toggle="tab"
										role="tab"
										aria-label="Prev"
										class="carousel-navigation swiper-button-prev swiper-button-prev-accommodation"
									></div>
									<div
										data-toggle="tab"
										role="tab"
										aria-label="Next"
										class="carousel-navigation swiper-button-next swiper-button-next-accommodation"
									></div>
								</div>
							</div>
						}
					</div>
				</div>
				<!-- Display as Card: 1 accommodation -->
				@if (accommodation.locations.length === 1) {
					<uc-accommodation-card
						[image]="accommodation.locations[0].image"
						[name]="accommodation.locations[0].name"
						[price]="accommodation.locations[0].price"
						[totalRooms]="accommodation.locations[0].total_rooms"
						[universityUrl]="universityUrl()"
						[uniId]="uniId()"
						[product]="product()"
						[externalUrl]="accommodation.external_url"
						[carousel]="false"
						[uniName]="uniName()"
						[ugSearchOrderPosition]="ugSearchOrderPosition()"
					/>
				}
				@if (accommodation.locations.length >= 2) {
					<div class="-mx-5">
						<!-- Display as Carousel: 2 accommodations or more -->
						<uc-accommodation-carousel
							ngSkipHydration
							[accommodationLocations]="accommodation.locations"
							[accommodationRank]="accommodation.rank"
							[accommodationRating]="accommodation.rating"
							[externalUrl]="accommodation.external_url"
							[universityUrl]="universityUrl()"
							[uniId]="uniId()"
							[product]="product()"
							[uniName]="uniName()"
							[ugSearchOrderPosition]="ugSearchOrderPosition()"
						/>
					</div>
				}
			</div>
		} @else {
			<uc-no-accommodation
				[universityExternalUrl]="universityExternalUrl()"
				[uniId]="uniId()"
				[uniName]="uniName()"
				[ugSearchOrderPosition]="ugSearchOrderPosition()"
				[product]="product()"
			/>
		}
	</section>
}
